import EventDetailComponentImage from "components/event/EventDetailComponentImage";
import EventDetailComponentWideProductCard from "components/event/EventDetailComponentWideProductCard";

import styles from "components/event/EventDetailComponents.module.scss";
import {OptionSwiper} from "components/swiper/OptionSwiper";
import {useRef} from "react";
import EventDetailComponentLargeProductCardPrice from "components/event/EventDetailComponentLargeProductCardPrice";
import EventDetailComponentLargeProductCardReview from "components/event/EventDetailComponentLargeProductCardReview";
import EventDetailComponentBrand from "components/event/EventDetailComponentBrand";
import {CurationSection} from "components/sections/curation/CurationSection";
import {EventDetailComponentsRef} from "components/event/EventDetailComponentsRef";
import EventTimerSection from "components/sections/curation/EventTimerSection";
import classNames from "classnames";


const EventDetailComponent = (props) => {
    const {component, rank, event, onCouponDownload, onLinkClick, isExpanded} = props;

    if (component.type === 'image') {
        return <EventDetailComponentImage
            key={`event-component-${component.id}`}
            imageInfo={
                {
                    detail_image_urls: component.detail_image_urls,
                    prevent_detail_images_fold: false,
                    detail_image_buttons: component.detail_image_buttons,
                }
            }
            {...props}
        />;
    } else if (component.type === 'wide_product_card') {
        return <EventDetailComponentWideProductCard
            key={`event-component-${component.id}`}
            product={component.product}
            productOption={component.product_option}
        />;
    } else if (component.type === 'large_product_card_price') {
        return <EventDetailComponentLargeProductCardPrice
            key={`event-component-${component.id}`}
            description={component.description}
            product={component.product}
        />;
    } else if (component.type === 'large_product_card_review') {
        return <EventDetailComponentLargeProductCardReview
            key={`event-component-${component.id}`}
            product={component.product}
            review={component.review}
            productOption={component.product_option}
        />;
    } else if (component.type === 'brand') {
        return <EventDetailComponentBrand
            key={`event-component-${component.id}`}
            brand={component.brand}
            onClick={onLinkClick}
            rank={rank}
            component={component}
        />;
    } else {
        return <></>;
    }
};

const EventDetailComponentHorizontalList = (props) => {
    const {component} = props;
    const localOptionSwiperIndex = useRef({});

    const theme = component?.theme || 'default';

    const renderItem = (item, index) => {
        return (
            <div className={styles[`theme-${theme}`]}>
                <EventDetailComponent
                    key={`horizontal-list-${component.id}-${item.id}`}
                    {...props}
                    component={item}
                />
            </div>
        )
    };

    return (
        <>
            <EventDetailComponentTitle component={component}/>
            <div
                className={styles.horizontalList}
                style={{
                    marginTop: component.title ? 24 : 0,
                    padding: component.children.length > 0 && component.children[0].type === 'wide_product_card' ? '16px 0' : '0',
                }}
            >
                <OptionSwiper
                    productOptions={component.children}
                    renderItem={renderItem}
                    postId={component.id}
                    optionSwiperIndex={localOptionSwiperIndex.current}
                />
            </div>
        </>
    )
};

const EventDetailComponentTitle = (props) => {
    const {component, marginBottom} = props;

    if (!component.title && !component.description) {
        return <></>;
    }

    return (
        <div className={styles[`theme-${component?.theme}`]} style={{marginBottom: marginBottom}}>
            <div className={styles.titleContainer}>
                {component.title && component.title.split('\n').map(
                    titleItem => <div className={styles.title}>{titleItem}</div>
                )}
                {component.description && component.description.split('\n').map(
                    item => {
                        return <div className={styles.description}>{item}</div>
                    }
                )}
            </div>
        </div>
    )
}

const EventDetailComponentVerticalList = (props) => {
    const {component} = props;

    const sortedChildren = component.children.sort((a, b) => b.rank - a.rank);
    const theme =  component?.theme || 'default';

    return (
        <div className={styles[`theme-${theme}`]}>
            <EventDetailComponentTitle component={component}/>
            <div
                className={styles.verticalList}
            >
                {
                    sortedChildren.map((item, index) => {
                        return (
                            <EventDetailComponent
                                key={`vertical-list-${component.id}-${item.id}-${index}`}
                                {...props}
                                component={item}
                                rank={index + 1}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
};


const EventDetailComponents = (props) => {
    const {event, onCouponDownload, onLinkClick, isExpanded, hasFixedTimerCuration} = props;

    const getEventComponent = (component) => {
        const onPouchAdd = () => {
            typeof mixpanel !== 'undefined' && mixpanel.track(
                'EventDetailComponentsPouchAdd',
                {
                    componentId: component.id,
                }
            );
        };
        if (component.type === 'image') {
            return <EventDetailComponentImage
                key={`event-component-${component.id}`}
                imageInfo={
                    {
                        detail_image_urls: component.detail_image_urls,
                        prevent_detail_images_fold: false,
                        detail_image_buttons: component.detail_image_buttons,
                    }
                }
                component={component}
                {...props}
            />;
        } else if (component.type === 'horizontal_list') {
            return <EventDetailComponentHorizontalList
                key={`event-component-${component.id}`}
                component={component}
                isAddToPouchVisible={Boolean(component.curation?.is_cart_button_visible)}
                {...props}
            />;
        } else if (component.type === 'vertical_list') {
            return <EventDetailComponentVerticalList
                key={`event-component-${component.id}`}
                component={component}
                isAddToPouchVisible={Boolean(component.curation?.is_cart_button_visible)}
                {...props}
            />;
        } else if (component.type === 'curation') {
            return <div>
                <EventDetailComponentTitle component={component} marginBottom={32}/>
                <CurationSection
                    theme={component?.theme}
                    key={`event-component-${component.id}`}
                    curation={component.curation}
                    location={'EventDetail'}
                    isAddToPouchVisible={Boolean(component.curation?.is_cart_button_visible)}
                    onPouchAdd={onPouchAdd}
                    useBestCouponDiscount={true}
                    {...props}
                />
            </div>;
        } else if(component.type === 'timer') {
            return (
                <EventTimerSection
                    {...component.attrs}
                    text={component.title}
                    endsAt={event.ends_at}
                    backgroundColor={component?.background_color}
                />
            )
        }
        return <></>;
    };


    const isStickyParent = (component) => {
        return hasFixedTimerCuration && component.type === 'timer';
    };

    return (
        <>
            {
                event.components.map((component, idx) => {
                    const padding = component?.padding?.split(',').map(p => parseInt(p));
                    const paddingTop = padding?.[0] || 0;
                    const paddingBottom = padding?.[1] || 0;
                    const backgroundColor = component?.background_color?.replace('#', '');

                    return (
                        <div
                            className={
                                classNames(styles.componentContainer, isStickyParent(component) && styles.stickyComponentContainer)
                            }
                            id={component.name}
                            style={
                                {
                                    paddingTop: paddingTop,
                                    paddingBottom: paddingBottom,
                                    marginTop: component?.margin_top,
                                    marginBottom: component?.margin_bottom,
                                    backgroundColor: `#${backgroundColor}`,
                                }
                            }
                            ref={el => EventDetailComponentsRef[`${event.id}_${component.name}`] = el}
                        >
                            {getEventComponent(component)}
                        </div>
                    )
                })
            }
        </>
    )
};

export default EventDetailComponents;
